<template>
    <div class="home-header" :class="{'home-header-fixed': isFixing}">
        <div class="home-header-wrap">
            <router-link :to="{name:'schedule@course'}">
                <img class="home-header-logo" src="../../../assets/images/download/download_logo_web.png" alt="好分数辅导logo">
            </router-link>
            <div class="home-header-content">
                <!--<div class="home-header-phone">-->
                    <!--<i></i>4008-180-190-->
                <!--</div>-->
                <div class="home-header-phone">
                    <i></i>客服电话
                    <ul class="home-header-phone-con">
                        <li>
                            电话1：4008-180-190
                        </li>
                        <li>
                            电话2：010-80455369
                        </li>
                    </ul>
                </div>
                <ul class="home-header-nav">
                    <li :class="{'active': $route.name === 'home'}">
                        <router-link :to="{name:'home'}">首页</router-link>
                    </li>
                    <li :class="{'active-download': $route.name === 'download'}">
                        <router-link :to="{name:'download'}">客户端下载</router-link>
                    </li>
                    <li v-show="$route.name === 'home' || $route.name === 'download'" class="move"></li>
                </ul>
                <div v-if="userInfo.name" class="user">
                    <img :src="userInfo.avatar" alt="头像" class="photo" v-if="userInfo.avatar">
                    <img src="../../../assets/images/common/tab_icon_touxiang.png" alt="头像" class="photo" v-else>
                    <span>Hi</span>
                    <span>{{ userInfo.name }}同学</span>
                    <ul class="home-header-menu">
                        <li>
                            <router-link :to="{name: 'basic@user'}">个人中心</router-link>
                        </li>
                        <li>
                            <a @click="quitLogin">退出登录</a>
                        </li>
                    </ul>
                </div>
                <div v-else class="home-header-option">
                    <div class="home-header-login">
                        登录
                        <ul class="home-header-menu-btn">
                            <li>
                                <router-link :to="{name: 'login@account', query: {userType: 2}}">学生登录</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'login@account', query: {userType: 3}}">家长登录</router-link>
                            </li>
                            <li>
                                <a :href="teacherUrlLogin" target="_blank">教师登录</a>
                            </li>
                        </ul>
                    </div>
                    <span class="home-header-split">|</span>
                    <div class="home-header-register">
                        注册
                        <ul class="home-header-menu-btn">
                            <li>
                                <router-link :to="{name: 'register@account', query: {userType: 2}}">注册学生</router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'register@account', query: {userType: 3}}">注册家长</router-link>
                            </li>
                            <li>
                                <a :href="teacherUrlRegister" target="_blank">注册老师</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';
const BaseUrl = feConfig.teacherApi.base;
export default {
    components: {
    },
    props: {
        isFixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isFixing: false,
            teacherUrlLogin: BaseUrl + '/account/login',
            teacherUrlRegister: BaseUrl + '/account/register'
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.profile
        })
    },
    watch: {
        isFixed(newValue) {
            this.isFixing = !!newValue;
        }
    },
    methods: {
        ...mapActions(['USER_DELETE_LOGOUT']),
        ...mapMutations(['USER_RESET_STATE']),
        quitLogin() {
            this.USER_DELETE_LOGOUT().then(() => {
                this.$router.push({ name: 'home' });
                this.USER_RESET_STATE();
            });
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.home-header {
    width: 100%;
    // position: absolute;
    top: 0;
    font-size: 14px;
    color: #fff;
    z-index: 9999;
    transition: all linear 0.5s;
    // background: -webkit-radial-gradient(#51b1fd, #5895f8);
    // background: -o-radial-gradient(#51b1fd, #5895f8);
    // background: -moz-radial-gradient(#51b1fd, #5895f8);
    // background: radial-gradient(#51b1fd, #5895f8);
    // background-image: linear-gradient(-37deg, #4582ff 0%, #0ac4ff 100%);
    background-image: linear-gradient(46deg, #ff8362 0%, #ff5344 100%);

    a {
        color: #fff;
        text-decoration: none;
    }
}

.home-header-fixed {
    position: fixed;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.home-header-wrap {
    width: 1200px;
    height: 56px;
    line-height: 56px;
    padding-left: 20px;
    padding-right: 20px;
    margin: 0 auto;
    box-sizing: border-box;
}

.home-header-logo {
    width: 150px;
    vertical-align: middle;
}

.home-header-content {
    float: right;
}

.home-header-phone {
    display: inline-block;
    position: relative;

    i {
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-right: 6px;
        background: url(../../../assets/images/homepage/phone_icon.png) no-repeat;
        background-size: contain;
        vertical-align: middle;
    }

    &:hover {
        & > .home-header-phone-con {
            display: block;
        }
    }
}

.home-header-nav {
    display: inline-block;
    margin-left: 54px;
    // margin-right: 54px;
    position: relative;

    li {
        display: inline-block;
        margin-right: 45px;

        &:last-child {
            margin-right: 0;
        }

        a {
            padding-top: 4px;
            padding-bottom: 4px;
        }
    }

    li.move {
        position: absolute;
        left: 0;
        top: 40px;
        width: 28px;
        height: 2px;
        border-bottom: 2px solid #fff;
        transition: all 0.5s ease-in-out 0s;
        -webkit-transition: all 0.3s ease-in-out 0s;
    }

    li:nth-child(1):hover ~ .move {
        left: 0;
        width: 28px;
    }

    li:nth-child(2):hover ~ .move {
        left: 78px;
        width: 70px;
    }

    .active ~ .move {
        left: 0;
        width: 28px;
    }

    .active-download ~ .move {
        left: 78px;
        width: 70px;
    }
}

.photo {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    vertical-align: middle;
}

.user {
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    position: relative;

    &:hover {
        .home-header-menu {
            display: block;
        }
    }

    span:first-of-type {
        margin-right: 5px;
    }

    .home-header-menu {
        display: none;
        position: absolute;
        top: 50px;
        right: 0;
        background-color: #fff;
        border-radius: 2px;
        z-index: 10;

        &::before {
            position: absolute;
            top: -16px;
            right: 40px;
            content: ' ';
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-bottom-color: #fff;
        }

        a {
            display: block;
            width: 100px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            text-decoration: none;
            color: #5a5e66;
            border-bottom: 1px solid #e7e7e7;
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
            }

            &:hover {
                background-color: #cddefd;
            }
        }
    }
}

.home-header-phone-con {
    display: none;
    position: absolute;
    top: 50px;
    right: -60px;
    background-color: #fff;
    border-radius: 2px;
    z-index: 9;

    &::before {
        position: absolute;
        top: -16px;
        right: 80px;
        content: ' ';
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-bottom-color: #fff;
    }

    li {
        display: block;
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        text-decoration: none;
        color: #5a5e66;
        border-bottom: 1px solid #e7e7e7;

        &:last-child {
            border-bottom: 0;
        }
    }
}

.home-header-option {
    display: inline-block;
    position: relative;

    .home-header-login {
        position: relative;
        display: inline-block;
        cursor: pointer;
        padding-left: 15px;
        padding-right: 15px;

        &:hover {
            & > .home-header-menu-btn {
                display: block;
            }
        }
    }

    .home-header-split {
        display: inline-block;
    }

    .home-header-register {
        position: relative;
        display: inline-block;
        padding-left: 15px;

        &:hover {
            & > .home-header-menu-btn {
                display: block;
            }
        }
    }

    .home-header-menu-btn {
        display: none;
        position: absolute;
        top: 50px;
        right: 0;
        background-color: #fff;
        border-radius: 2px;
        z-index: 10;

        &::before {
            position: absolute;
            top: -16px;
            right: 6px;
            content: ' ';
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-bottom-color: #fff;
        }

        a {
            display: block;
            width: 100px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            text-decoration: none;
            color: #5a5e66;
            border-bottom: 1px solid #e7e7e7;
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
            }

            &:hover {
                background-color: #cddefd;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppHeader.vue